module.exports = __webpack_public_path__ + "media/images/icon-60e6896dd3b528d6a3f9bd1aef8b66f3.ico";